<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Corporate</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Company
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Company <span><i class="ic-office"></i></span>
                  </h2>
                  <p>
                    Manage your customer company details, or create internal
                    business departments as companies for reporting.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Company Name"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>
                    Company
                    <span class="button-sort" @click="onClickSort('name')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th v-if="userType === 'TenantUser'">
                    Preferred Provider(s)
                  </th>
                  <th>
                    Phone
                    <span class="button-sort" @click="onClickSort('phone')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>
                    Email
                    <span class="button-sort" @click="onClickSort('email')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th class="text-left">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td
                    v-if="userType === 'TenantUser'"
                    :title="printCommaBasedProviders(item.preferredProviders)"
                  >
                    <span :class="{ 'sts-danger': !item.hasProvider }">{{
                      printProviders(item.preferredProviders)
                    }}</span>
                  </td>
                  <td>
                    <span :class="{ 'sts-danger': !item.hasPhone }">{{
                      item.phoneCode && item.phoneNumber
                        ? `(+${item.phoneCode}) ${item.phoneNumber}`
                        : "N/A"
                    }}</span>
                  </td>
                  <td>
                    <span :class="{ 'sts-danger': !item.hasEmail }">{{
                      item.email ? item.email : "N/A"
                    }}</span>
                  </td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        v-if="isAllowToDelete"
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="companymodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Company</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body mt-5">
                  <ul
                    class="nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"
                  >
                    <li :class="[activeTab === 'general' ? 'active' : '']">
                      <a
                        href="#company-general"
                        data-toggle="tab"
                        @click="activeTab = 'general'"
                      >
                        <span class="required">General</span>
                      </a>
                    </li>
                    <li
                      :class="[activeTab === 'payment' ? 'active' : '']"
                      v-if="isAllowToSetupPayment"
                    >
                      <a
                        href="#company-payment"
                        data-toggle="tab"
                        @click="activeTab = 'payment'"
                      >
                        <span class="required">Payment</span>
                      </a>
                    </li>
                    <li
                      :class="[activeTab === 'provider' ? 'active' : '']"
                      v-if="isAllowToSetupProvider"
                    >
                      <a
                        href="#company-provider"
                        data-toggle="tab"
                        title="Preferred Provider"
                        @click="activeTab = 'provider'"
                      >
                        <span class="required">Pref. Provider</span>
                      </a>
                    </li>
                  </ul>
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="tab-content">
                      <div
                        id="company-general"
                        class="tab-pane fade"
                        :class="[activeTab === 'general' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Name</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.name.$error,
                                }"
                                autocomplete="off"
                                v-model="model.name"
                              />
                              <div v-if="isSubmitted && $v.model.name.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.required"
                                  >Name is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.maxLength"
                                  >Name must be less than
                                  {{ $v.model.name.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Currency</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.preferredCurrencyCode.$error,
                                }"
                                placeholder=""
                                label="text"
                                v-model="model.preferredCurrencyCode"
                                :options="currencies"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                              >
                              </v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.model.preferredCurrencyCode.required
                                "
                                >Currency Code is required</small
                              >
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Email</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.email.$error,
                                }"
                                autocomplete="off"
                                v-model="model.email"
                              />
                              <div v-if="isSubmitted && $v.model.email.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.email.email"
                                  >Email is invalid</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.email.maxLength"
                                  >Email must be less than
                                  {{ $v.model.email.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Alternate Email</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.alternateEmail.$error,
                                }"
                                autocomplete="off"
                                v-model="model.alternateEmail"
                              />
                              <div
                                v-if="
                                  isSubmitted && $v.model.alternateEmail.$error
                                "
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.alternateEmail.email"
                                  >Alt. Email is invalid</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.alternateEmail.maxLength"
                                  >Alt. Email must be less than
                                  {{
                                    $v.model.alternateEmail.$params.maxLength
                                      .max
                                  }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <label>Phone</label>
                            <div class="row">
                              <div class="col-sm-5">
                                <div class="form-group">
                                  <v-select
                                    class="v-search-select"
                                    placeholder=""
                                    label="label"
                                    v-model="model.phoneCode"
                                    :options="phoneCodes"
                                    :filter="searchPhoneCode"
                                    :clearable="false"
                                    :searchable="true"
                                    :filterable="true"
                                    :reduce="(option) => option.dial"
                                  >
                                    <template slot="option" slot-scope="option">
                                      <div class="phone-wrapper">
                                        <div
                                          class="phone-icon"
                                          :class="option.icon"
                                        ></div>
                                        <div class="phone-text">
                                          {{ option.country }}
                                        </div>
                                      </div>
                                    </template>
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-sm-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control numbers-only"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.phoneNumber.$error,
                                    }"
                                    autocomplete="off"
                                    v-model="model.phoneNumber"
                                  />
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      isSubmitted &&
                                      !$v.model.phoneNumber.maxLength
                                    "
                                    >Phone Number must be less than
                                    {{
                                      $v.model.phoneNumber.$params.maxLength.max
                                    }}
                                    characters</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <label>Alternate Phone</label>
                            <div class="row">
                              <div class="col-sm-5">
                                <div class="form-group">
                                  <v-select
                                    class="v-search-select"
                                    placeholder=""
                                    label="label"
                                    v-model="model.alternatePhoneCode"
                                    :options="phoneCodes"
                                    :filter="searchPhoneCode"
                                    :clearable="false"
                                    :searchable="true"
                                    :filterable="true"
                                    :reduce="(option) => option.dial"
                                  >
                                    <template slot="option" slot-scope="option">
                                      <div class="phone-wrapper">
                                        <div
                                          class="phone-icon"
                                          :class="option.icon"
                                        ></div>
                                        <div class="phone-text">
                                          {{ option.country }}
                                        </div>
                                      </div>
                                    </template>
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-sm-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control numbers-only"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.alternatePhoneNumber.$error,
                                    }"
                                    autocomplete="off"
                                    v-model="model.alternatePhoneNumber"
                                  />
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      isSubmitted &&
                                      !$v.model.alternatePhoneNumber.maxLength
                                    "
                                    >Alt. Phone Number must be less than
                                    {{
                                      $v.model.alternatePhoneNumber.$params
                                        .maxLength.max
                                    }}
                                    characters</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Address</label>
                              <textarea
                                class="form-control"
                                rows="4"
                                v-model="location.address"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <button
                              type="button"
                              id="btn-map"
                              class="btn btn-default"
                              @click.prevent="openMapModal()"
                            >
                              <i class="ic-map"></i>
                              Select Location by Map
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="company-payment"
                        class="tab-pane fade"
                        :class="[activeTab === 'payment' ? 'in active' : '']"
                        v-if="isAllowToSetupPayment"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  v-model="model.isEnableCorporateAccount"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  Enable Company Account
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  v-model="model.isEnableInvoice"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  Enable Payment by Invoice
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-if="model.isEnableCorporateAccount">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  v-model="model.isDisplayAccountBalance"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  Display Balance on Reservation
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  v-model="model.isEnablePaymentGateway"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  Enable Payment Gateway
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div
                              class="form-group"
                              v-if="model.isEnablePaymentGateway"
                            >
                              <label class="required">Default Channel</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.preferredPaymentGateway.$error,
                                }"
                                placeholder=""
                                label="text"
                                v-model="model.preferredPaymentGateway"
                                :options="paymentGateways"
                                :clearable="false"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                              >
                              </v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.model.preferredPaymentGateway.required
                                "
                                >Payment Gateway is required</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="company-provider"
                        class="tab-pane fade"
                        :class="[activeTab === 'provider' ? 'in active' : '']"
                        v-if="isAllowToSetupProvider"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <div class="d-flex py-2">
                                <label>Provider</label>
                                <button
                                  type="button"
                                  class="btn-select-all ml-5"
                                  @click="onSelectAll()"
                                >
                                  Select All
                                </button>
                                <button
                                  type="button"
                                  class="btn-clear-all ml-5"
                                  @click="onClearAll()"
                                  v-if="hasPrefProviders"
                                >
                                  Clear All
                                </button>
                              </div>
                              <multiselect
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.preferredProviders.$error,
                                }"
                                v-model="model.preferredProviders"
                                :options="providers"
                                :multiple="true"
                                :close-on-select="false"
                                :limit="1"
                                placeholder="Select provider"
                                label="name"
                                track-by="id"
                              ></multiselect>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.model.preferredProviders.required
                                "
                                >Provider is required</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-header modal-new" :class="{ update: isUpdate }">
          <div class="row">
            <div class="col-sm-10">
              <h4>Company Location</h4>
              <h6 v-if="model.modifiedDate">
                Last Updated: {{ model.modifiedDate.stringFullDate }}
              </h6>
            </div>
            <div class="col-sm-2">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i class="ic-close"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <div class="gmap-wrapper">
              <div class="pac-card" id="pac-card">
                <div id="pac-container">
                  <input
                    id="pac-input"
                    type="text"
                    placeholder="Enter a location"
                  />
                </div>
              </div>
              <div id="map"></div>
              <div class="modal-footer text-center">
                <div id="gmap-custom-control">
                  <button type="button" class="btn btn-default remove-location">
                    Reset
                  </button>
                  <button type="button" class="btn btn-primary save-location">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, email, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import providerService from "@/services/master/provider/providerService.js";
import companyService from "@/services/master/company/companyService.js";
import countryPhoneService from "@/services/master/countryPhoneService.js";
import maverickMap from "@/plugins/google/map.js";
import maverickGeocoding from "@/plugins/google/geocode.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    isAllowToSetupPayment: function () {
      return this.allPermissions.includes("SetupPayment");
    },
    isAllowToSetupProvider: function () {
      return this.allPermissions.includes("SetupProvider");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    validationRulePaymentGateway: function () {
      return this.model.isEnablePaymentGateway ? { required } : {};
    },
    hasPrefProviders: function () {
      return (
        this.model.preferredProviders && this.model.preferredProviders.length
      );
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
      },
      isSubmitted: false,
      activeTab: "general",
      publicSettings: [],
      allPermissions: [],
      itemToBeDeleted: null,
      map: null,
      geocoder: null,
      providers: [],
      currencies: [],
      phoneCodes: [],
      paymentGateways: [],
      items: [],
      model: {},
      location: { name: null, address: null, latitude: null, longitude: null },
      isUpdate: false,
      isLoading: false,
      userType: "Unspecified",
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        name: { required, maxLength: maxLength(150) },
        preferredCurrencyCode: { required },
        preferredPaymentGateway: this.validationRulePaymentGateway,
        email: { email, maxLength: maxLength(100) },
        alternateEmail: { email, maxLength: maxLength(100) },
        phoneNumber: { maxLength: maxLength(20) },
        alternatePhoneNumber: { maxLength: maxLength(20) },
        preferredProviders: { required },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    this.publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      this.publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    this.userType = profile.userType;

    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getPhoneCodes();
      await this.getProviders();
      this.currencies = [
        { text: "AUD", value: "AUD" },
        { text: "HKD", value: "HKD" },
        { text: "IDR", value: "IDR" },
        { text: "MYR", value: "MYR" },
        { text: "SGD", value: "SGD" },
        { text: "THB", value: "THB" },
      ];
      this.paymentGateways = [
        // { text: "Red Dot Payment", value: "RedDotPayment" },
        // { text: "PayPal", value: "PayPal" },
        { text: "Airwallex", value: "Airwallex" },
      ];
    }
  },
  mounted() {
    $(this.$refs.companymodal).on("hidden.bs.modal", this.closeCompanyModal);
    $(this.$refs.mapmodal).on("hidden.bs.modal", this.closeMapModal);

    if (!this.map) {
      const defaultLatLng = this.$helper.extractSetting(
        this.publicSettings,
        "DefaultLatLng",
        "-6.17003832454938|106.81490242481232"
      );
      const latLng = defaultLatLng.split("|");
      const lat = parseFloat(latLng[0]);
      const lng = parseFloat(latLng[1]);

      // creates map instance
      this.map = new maverickMap({
        mapId: "map",
        lat: lat,
        lng: lng,
        marker: true,
        autocomplete: true,
        confirmLocationCallback: this.confirmLocation,
        removeLocationCallback: this.removeLocation,
        autoCompleteGetPlaceCallback: this.getPlace,
        markerChangeCallback: this.markerChange,
      });
      this.map.initialize();
    }

    if (!this.geocoder) {
      // creates geocoder instance
      this.geocoder = new maverickGeocoding();
    }
  },
  updated() {
    this.$helper.collapseMenu("corporate");
    this.$helper.setNavigationClass("company-link");
    this.$helper.alphabetsOnly();
    this.$helper.numbersOnly();
  },
  beforeDestroy() {
    document
      .querySelectorAll(".pac-container")
      .forEach((element) => element.remove());
  },
  methods: {
    onSelectAll() {
      this.model.preferredProviders = this.providers;
    },
    onClearAll() {
      this.model.preferredProviders = null;
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async onClickSort(column) {
      if (this.table.sort === column) {
        this.table.sortDir = this.table.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.table.sortDir = "asc";
      }
      this.table.sort = column;
      await this.getAll();
    },
    async confirmLocation(coordinate) {
      // get place from geocoding
      if (this.isMarkerChange) {
        let geocodeResponse = await this.geocoder.geocode(coordinate);
        if (geocodeResponse !== undefined && geocodeResponse !== null) {
          this.location.address = geocodeResponse.address;
          this.location.name = geocodeResponse.name;
          this.location.latitude = geocodeResponse.latitude;
          this.location.longitude = geocodeResponse.longitude;
        }
      }
      this.$notification.success("Location saved.", { title: "Success" });
      this.closeMapModal();
    },
    removeLocation() {
      document.getElementById("pac-input").value = "";
      this.resetModel();
      this.$notification.success("Location removed.", { title: "Success" });
    },
    getPlace(place) {
      // get place from autocomplete
      this.isMarkerChange = false;
      this.location.name = place.name;
      this.location.address = place.formatted_address;
      this.location.latitude = place.geometry.location.lat();
      this.location.longitude = place.geometry.location.lng();
    },
    markerChange(latLng) {
      this.isMarkerChange = true;
    },
    resetModel() {
      this.isMarkerChange = false;
      this.model = {};
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null,
      };
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    searchPhoneCode(options, search) {
      const pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter((item) => {
        return (
          pattern.test(item.area) ||
          pattern.test(item.country) ||
          pattern.test(item.dial) ||
          pattern.test(item.iata)
        );
      });
    },
    openCompanyModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      if (this.model.location !== undefined && this.model.location !== null) {
        this.location = this.model.location;
      }
      $(this.$refs.companymodal).modal({ backdrop: "static", keyboard: false });
    },
    openMapModal(object) {
      document.getElementById("pac-input").value = "";
      this.resetValidations();
      if (
        this.location !== null &&
        this.location.latitude !== null &&
        this.location.longitude !== null
      ) {
        this.map.showMarker(
          new google.maps.LatLng(
            this.location.latitude,
            this.location.longitude
          )
        );
      } else {
        this.map.hideMarker();
      }
      $(this.$refs.mapmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeCompanyModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.companymodal).modal("hide");
    },
    closeMapModal() {
      $(this.$refs.mapmodal).modal("hide");
      $(this.$refs.companymodal).css("overflow-y", "auto");
    },
    createItem() {
      this.isUpdate = false;
      this.resetModel();
      this.activeTab = "general";
      this.openCompanyModal({
        isEnableCorporateAccount: true,
        isEnablePaymentGateway: true,
        isEnableInvoice: false,
        preferredProviders: [],
        providerId: null,
        preferredPaymentGateway: "Airwallex",
      });
    },
    updateItem(item) {
      this.isUpdate = true;
      this.activeTab = "general";
      this.openCompanyModal(item);
    },
    async getPhoneCodes() {
      this.phoneCodes = await countryPhoneService.getAll();

      for (let i = 0; i < this.phoneCodes.length; i++) {
        const item = this.phoneCodes[i];
        item.label = `${item.iata} (+${item.dial})`;
        item.icon = `iti-flag ${item.iata.toLowerCase()}`;
      }
    },
    async getProviders() {
      this.providers = await providerService.getAllActive();
      console.log(this.providers);
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        if (this.table.sort && this.table.sort !== "") {
          filter += `&sort=${this.table.sort}&sortDir=${this.table.sortDir}`;
        }
        const response = await companyService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;

        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];
          item.hasProvider =
            item.preferredProviders && item.preferredProviders.length > 0;
          item.hasPhone =
            item.phoneCode &&
            item.phoneCode !== "" &&
            item.phoneNumber &&
            item.phoneNumber !== "";
          item.hasEmail = item.email && item.email !== "";
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        if (
          this.location.address !== null &&
          this.location.name !== null &&
          this.location.latitude !== null &&
          this.longitude !== null
        ) {
          this.model.location = this.location;
        } else {
          this.model.location = null;
        }
        this.model.preferredProviders = this.model.preferredProviders.map(
          (x) => x.id
        );
        if (this.isUpdate) {
          await companyService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await companyService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        this.closeCompanyModal();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await companyService.changeStatus({
          id: item.id,
          isActive: item.isActive,
        });
        if (item.isActive) {
          this.$notification.success("Successfully reactivated.", {
            title: "Success",
          });
        } else {
          this.$notification.success("Successfully deactivated.", {
            title: "Success",
          });
        }
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await companyService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printProviders(item) {
      if (item.length === 0) {
        return "N/A";
      } else if (item.length === 1) {
        return item[0].name;
      } else {
        return `${item.length} providers`;
      }
    },
    printCommaBasedProviders(item) {
      return item.map((x) => x.name).join(", ");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/company/Company.vue